import{flatten as t}from"@fluentui/react";const r=r=>`${t(r.map((t=>`'${t.join(" ")}'`))).join(" ")}`,o=t=>{if(t||"number"==typeof t)return isNaN(Number(t))?t.toString():`${t.toString()}px`};export{o as formatValue,r as getGridTemplateAreas};
//# sourceMappingURL=utils.js.map
